import React from "react";
import Classes from "./index.module.css";

const BorderBox = ({children,className})=>{
    return(
        <div className={`${className} ${Classes.borderBox}`}>
            <span>{children}</span>
        </div>
    );
}

export default BorderBox;